import styled from 'styled-components'

export default styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  marginBottom: 8,
  textAlign: 'left',
})
